export enum HttpMethod {
   GET = "GET",
   POST = "POST",
   PUT = "PUT",
   PATCH = "PATCH",
   DELETE = "DELETE",
   HEAD = "HEAD",
   OPTIONS = "OPTIONS",
   TRACE = "TRACE",
}
